import "./RaikoIcons.scss"

export const RaikoIconTypes = {
    icTrash: "icTrash",
    icAndroidOs:"icAndroidOs",
    icAndroidOsGray:"icAndroidOsGray",
    icDeleteBorder: "ic-delete",
    icLink: "ic-link",
    icClose: "ic-close",
}